import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import {
  CiiuModel,
  EmployedContractModel,
  FinancialModel,
  OfficeModel,
  OtherFinancialModel,
  PcoModel,
  TypeContractModel,
} from 'src/app/shared/models/abre-cuentas.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { StringHelperService } from 'src/app/shared/services/helpers/string-helper.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { ValidationHelperService } from '../../../shared/services/helpers/validation-helper.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ERROR_LIB } from 'src/app/shared/constants/abre-cuentas.constants';

@Component({
  selector: 'app-client-data-update',
  templateUrl: './client-data-update.component.html',
  styleUrls: ['./client-data-update.component.scss'],
})
export class ClientDataUpdateComponent implements OnInit, AfterViewInit {
  // peso = { code: 'COP', locale: 'es-co', decimal: 0, display: 'symbol' };
  city_option: any;
  city_option_work: any;
  selectedCityResidence: any;
  formGroup: FormGroup;
  addressResidence: any;
  selectedLivingResidence: any;
  living_option: any;
  livingPlace: any;
  selectedStratum: any;
  stratum_option: any;
  stratumValue: any;
  civil_status_options: any;
  selectedCivilStatus: any;
  civilStatusValue: any;
  emailAddress: any;
  phoneContact: any;
  minimumDate: any;
  maximumDate: any;
  selectedDate: any;
  company: any;
  selectContract: any;
  selectOtherOriginIncome: any;
  selectOriginIncome: 0;
  contract_option: any;
  independent_option: any;
  selecteCityWork: any;
  addressWork: any;
  phoneCompany: any;
  income: any;
  origin_options: any;
  radioIncome: any;
  origin_other_option: any;
  valueOtherIncomes: any;
  valueExpenses: any;
  valueDebts: any;
  valueGoods: any;
  product_type: string;
  personalData: boolean;
  laboralData: boolean;
  financialData: boolean;
  showOtherIncomes: boolean;
  ciiu_options: any;
  ciiu: any;
  ciiu_show: boolean;
  contract_show: boolean;
  company_show: boolean;
  city_work_show: boolean;
  address_work_show: boolean;
  phone_work_show: boolean;
  incomesSourceSelection: any;
  financialInfo: FinancialModel;
  otherFinancialInfo: OtherFinancialModel;
  officeInfo: OfficeModel;
  employedModel: EmployedContractModel;
  typeContracts: TypeContractModel[] = [];
  contract?: TypeContractModel;
  date: any;
  selectedCiiu: CiiuModel;
  confirmData = false;
  backLabel: any;
  formControls: any;
  ciiuSelected: any;
  occupationSelected: any;
  pcoAmountValidation: boolean;
  date_button: boolean;
  other_btn_show: boolean;
  // stateDateContract: boolean;
  timeText: any;
  // errorInfo: ErrorModel;
  district_option: any;
  isDisabledCity = true;
  isDisabledCityWork = true;
  closeLoading = false;
  loanNormalization = false;

  flagOperador: boolean;
  config = {
    allowNegative: false,
    decimal: ',',
    precision: 0,
    thousands: '.',
    prefix: '$ ',
  };
  taggingService: any;
  chanelid: string;
  dataClient: any;
  ciiuInfo: any;

  optionsCiiu: any[];
  selectedGeneral: any;
  enableDetail = false;
  optionsFilter: any[];

  constructor(
    private headerService: HeaderService,
    public copyService: CopyService,
    private parametersService: ParametersService,
    private abreCuentasService: AbreCuentasService,
    private formBuilder: FormBuilder,
    private stringHelperService: StringHelperService,
    private helperService: HelpersService,
    private validationHelperService: ValidationHelperService,
    private navigationService: NavigationService,
    private captureService: CaptureService,
    private bitacoraService: BitacoraService,
    private cdr: ChangeDetectorRef,
    private productLoaderService: ProductLoaderService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private formatNumber: FormatNumberService,
    private requestService: RequestService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
    this.personalData = true;
    this.laboralData = true;
    this.financialData = true;
    this.showOtherIncomes = false;
    this.ciiu_show = true;
    this.contract_show = true;
    this.company_show = true;
    this.city_work_show = true;
    this.address_work_show = true;
    this.phone_work_show = true;
    this.backLabel = false;
    this.date_button = false;
    this.other_btn_show = true;
    // this.stateDateContract = false;
    this.getDistrict();
  }

  ngOnInit(): void {
    this.navigationService.pageLoadTag(false, ['pv434', '', '', '']);
    this.bitacoraService.saveDataInBitacora('Int_client_data_update');
    this.chanelid = CHANNEL.PORTALO.CODE;
    this.flagOperador = this.channelCommunicatorService.getChannelId() === this.chanelid;
    // const formatNumber = new FormatNumberService();
    this.formGroup = new FormGroup({
      districtValue: new FormControl('', [Validators.required]),
      cityResidence: new FormControl('', [Validators.required]),
      addressResidence: new FormControl(
        '',
        [
          Validators.required, Validators.minLength(4),
          Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
        ]),
      livingPlace: new FormControl('', [Validators.required]),
      stratum: new FormControl('', [Validators.required]),
      civilStatus: new FormControl('', [Validators.required]),
      emailAddress: new FormControl({ value: '', disabled: this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE ? false : true }),
      phoneContact: new FormControl({ value: '', disabled: this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE ? false : true }),
      company: new FormControl(''),
      ciiu: new FormControl(''),
      ciiuGeneral: new FormControl(''),
      contract: new FormControl(''),
      districtWorkValue: new FormControl(''),
      cityWorking: new FormControl(''),
      addressWork: new FormControl(''),
      phoneCompany: new FormControl(''),
      origin: new FormControl('', [Validators.required]),
      income: new FormControl('', [Validators.required, Validators.min(10000)]),
      originOtherIncome: new FormControl(''),
      OtherIncomes: new FormControl(''),
      Expenses: new FormControl('', [Validators.required]),
      Debts: new FormControl('', [Validators.required]),
      Goods: new FormControl('', [Validators.required]),
    });
    this.formControls = this.formGroup.controls;
    this.maximumDate = new Date('dd/mm/yyyy');
    this.employedModel = this.abreCuentasService.getEmployedContractModel();
    this.selectedDate = this.employedModel.contractDate;
    this.occupationSelected = this.abreCuentasService.getOccupationSelected();
    switch (this.occupationSelected.name) {
      case 'Pensionado':
        this.formControls.ciiu.setValidators([Validators.nullValidator]);
        this.formControls.ciiuGeneral.setValidators([Validators.nullValidator]);
        this.formControls.company.setValidators([Validators.nullValidator]);
        this.formControls.contract.setValidators([Validators.nullValidator]);
        this.formControls.districtWorkValue.setValidators([Validators.nullValidator]);
        this.formControls.cityWorking.setValidators([Validators.nullValidator]);
        this.formControls.addressWork.setValidators([Validators.nullValidator]);
        this.formControls.phoneCompany.setValidators([Validators.nullValidator]);
        this.laboralData = false;
        this.date_button = true;
        break;
      case 'Estudiante':
        this.formControls.ciiu.setValidators([Validators.nullValidator]);
        this.formControls.ciiuGeneral.setValidators([Validators.nullValidator]);
        this.formControls.company.setValidators([Validators.nullValidator]);
        this.formControls.contract.setValidators([Validators.nullValidator]);
        this.formControls.districtWorkValue.setValidators([Validators.nullValidator]);
        this.formControls.cityWorking.setValidators([Validators.nullValidator]);
        this.formControls.addressWork.setValidators([Validators.nullValidator]);
        this.formControls.phoneCompany.setValidators([Validators.nullValidator]);
        this.laboralData = false;
        this.date_button = true;
        break;
      case 'Hogar':
        this.formControls.ciiu.setValidators([Validators.nullValidator]);
        this.formControls.ciiuGeneral.setValidators([Validators.nullValidator]);
        this.formControls.company.setValidators([Validators.nullValidator]);
        this.formControls.contract.setValidators([Validators.nullValidator]);
        this.formControls.districtWorkValue.setValidators([Validators.nullValidator]);
        this.formControls.cityWorking.setValidators([Validators.nullValidator]);
        this.formControls.addressWork.setValidators([Validators.nullValidator]);
        this.formControls.phoneCompany.setValidators([Validators.nullValidator]);
        this.laboralData = false;
        this.date_button = true;
        break;
      case 'Empleado':
        this.formControls.ciiu.setValidators([Validators.nullValidator]);
        this.formControls.ciiuGeneral.setValidators([Validators.nullValidator]);
        this.formControls.company.setValidators([Validators.required]);
        this.formControls.contract.setValidators([Validators.required]);
        this.formControls.districtWorkValue.setValidators([Validators.required]);
        this.formControls.cityWorking.setValidators([Validators.required]);
        this.formControls.addressWork.setValidators([
          Validators.required, Validators.minLength(4), Validators.maxLength(40),
          Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
        ]);
        this.formControls.phoneCompany.setValidators([Validators.required, Validators.pattern(/^([1-9]{1,1}[0-9]{6,9})$/)]);
        this.ciiu_show = false;
        this.date_button = this.selectedDate ? true : false;
        break;
      case 'Independiente':
        this.formControls.contract.setValidators([Validators.nullValidator]);
        this.formControls.ciiuGeneral.setValidators([Validators.required]);
        this.formControls.ciiu.setValidators([Validators.required]);
        this.formControls.company.setValidators([Validators.required]);
        this.formControls.districtWorkValue.setValidators([Validators.required]);
        this.formControls.cityWorking.setValidators([Validators.required]);
        this.formControls.addressWork.setValidators([
          Validators.required, Validators.minLength(4), Validators.maxLength(40),
          Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
        ]);
        this.formControls.phoneCompany.setValidators([Validators.required, Validators.pattern(/^([1-9]{1,1}[0-9]{6,9})$/)]);
        this.contract_show = false;
        this.ciiuSelected = this.abreCuentasService.getCiiuSelected();
        this.selectedDate = this.abreCuentasService.getCiiuDate();
        this.date_button = this.selectedDate ? true : false;
        break;
      default:
        this.formControls.contract.setValidators([Validators.nullValidator]);
        this.formControls.ciiu.setValidators([Validators.required]);
        this.formControls.ciiuGeneral.setValidators([Validators.required]);
        this.formControls.company.setValidators([Validators.required]);
        this.formControls.districtWorkValue.setValidators([Validators.required]);
        this.formControls.cityWorking.setValidators([Validators.required]);
        this.formControls.addressWork.setValidators([
          Validators.required, Validators.minLength(4), Validators.maxLength(40),
          Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
        ]);
        this.formControls.phoneCompany.setValidators([Validators.required, Validators.pattern(/^([1-9]{1,1}[0-9]{6,9})$/)]);
        this.contract_show = false;
        this.ciiuSelected = this.abreCuentasService.getCiiuSelected();
        this.selectedDate = this.abreCuentasService.getCiiuDate();
        console.log('this.selectedDate............', this.selectedDate);
        this.date_button = this.selectedDate ? true : false;
        break;
    }
    this.product_type = this.abreCuentasService.getproductSelected().product_type;
    this.city_option = this.parametersService.getSetting(OpEnum.CITY_LIST);
    this.living_option = this.parametersService.getSetting(OpEnum.HOUSING_TYPE);
    this.stratum_option = this.parametersService.getSetting(OpEnum.STRATUM);
    this.civil_status_options = this.parametersService.getSetting(OpEnum.CIVIL_STATUS_LIST);
    const occupationTime = this.parametersService.getSetting(OpEnum.OCUPATION_TIME_TC);
    this.contract_option = occupationTime ? occupationTime['list_dependent_time'] :
      this.abreCuentasService.getListTypeContract();
    if (this.abreCuentasService.getFlowLoan() && this.abreCuentasService.getOccupationSelected().id === 1) {
      this.contract_option = this.parametersService.getSetting(OpEnum.LIST_TYPE_CONTRACT_LOAN);
    }
    this.independent_option = this.occupationSelected.id === 2 ? occupationTime['independent_time'] : 0;
    this.origin_options = this.parametersService.getSetting(OpEnum.SOURCE_OF_FUNDS);
    this.optionsCiiu = this.parametersService.getSetting(OpEnum.CIIU_GENERAL_LIST);
    this.ciiu_options = this.parametersService.getSetting(OpEnum.CIIU_LIST);
    this.optionsFilter = this.ciiu_options;
    let user_info = this.abreCuentasService.getContactInfo();
    this.dataClient = this.abreCuentasService.getCustomerData();
    this.ciiuInfo = this.ciiu_options.filter(activity => activity.ciiu === this.dataClient.basic.professional_activity
      .find((item: { key: string; name: string }) => item.key === 'sic')
      .name.toString()
      .replace(/^(\d{1})$/g, '00$1')
      .replace(/^(\d{2})$/g, '0$1'),
    )[0];
    user_info.address.address = user_info.address.address.trim() == '' ? this.dataClient.address.addresses.filter(e => (e.type == '1'))[0].street.trim() : user_info.address.address.trim();
    let districtResidense = this.dataClient.basic.addresses.district;
    if (districtResidense === null || districtResidense === undefined) {
      districtResidense = '';
    }
    this.officeInfo = this.abreCuentasService.getOfficeInfo(this.occupationSelected.id);
    let addressOffice = this.dataClient.address.addresses.filter(e => (e.type === '2') || (e.type === '3') ||
      (e.type === '11') || (e.type === '5'));
    let flag_type = false;
    for (const iterator of addressOffice) {
      if (iterator.type === '5') {
        flag_type = true;
      }
    }
    addressOffice = flag_type ? addressOffice.find(e => (e.type === '5')) : addressOffice.find(e => (e.type === '3') ||
      (e.type === '11') || (e.type === '2'));
    if (addressOffice === undefined || addressOffice === null) {
      addressOffice = '';
    }
    let mobilePhoneOffice = this.dataClient.contact.phones.find(e => {
      const code = e.phone_type.split('-')[0];
      if (code === '5' || code === '2' || code === '11') {
        return e;
      }
    });
    this.phoneCompany = mobilePhoneOffice;
    if (mobilePhoneOffice === null || mobilePhoneOffice === undefined) {
      mobilePhoneOffice = '';
    }
    this.addressWork = addressOffice;
    this.selecteCityWork = this.city_option.filter(ei =>
      (ei.city_code === addressOffice.city) && (ei.province_code === parseInt(addressOffice.district, 10)));
    if (addressOffice.city === '997') {
      this.selecteCityWork = '';
    }
    if (this.selecteCityWork === undefined || this.selecteCityWork === null) {
      this.selecteCityWork = '';
    }
    if (this.selecteCityWork.length > 0) {
      this.selecteCityWork[0].description = this.selecteCityWork[0].description.toUpperCase();
    }
    const basicData = this.dataClient.basic;
    const aditionalInformation = basicData.additional_information.filter(element => {
      return element.key === 'Total Ingresos';
    });
    let aditional = 0;
    const aditionalInfo = aditionalInformation.forEach(element => {
      aditional = parseInt(element.name.replace(/[$,]/g, ''), 10);
      console.log(aditionalInfo);
    });
    this.setCiiuGeneralOptions();
    this.formControls.ciiu.setValue(this.ciiuInfo);
    this.formControls.addressResidence.setValue(user_info.address.address);
    this.flagOperador ? this.formControls.emailAddress.setValue(user_info.email) : this.formControls.emailAddress.setValue(this.validationHelperService.maskMail(user_info.email));
    this.flagOperador ? this.formControls.phoneContact.setValue(user_info.mobile_number) : this.formControls.phoneContact.setValue(this.validationHelperService.maskPhone(user_info.mobile_number));
    this.formControls.company.setValue(this.officeInfo.company_name);
    this.formControls.addressWork.setValue(this.officeInfo.address.addressInput);
    this.formControls.phoneCompany.setValue(this.officeInfo.office_number);
    this.selectedCityResidence = user_info.address.city;
    this.selectedLivingResidence = user_info.address.housingType ? user_info.address.housingType.description : null;
    this.selectedLivingResidence = this.selectedLivingResidence ?
      this.helperService.validateDiacritialMask(this.selectedLivingResidence) : '';
    this.selectedStratum = user_info.address.stratum;
    this.selectedCivilStatus = this.abreCuentasService.getMaritalStatusInfo() ? this.helperService.validateDiacritialMask(
      this.abreCuentasService.getMaritalStatusInfo().marital_status_description) : '';
    this.addressResidence = user_info.address.address;
    this.flagOperador ? this.emailAddress = user_info.email : this.emailAddress = this.validationHelperService.maskMail(user_info.email);
    this.flagOperador ? this.phoneContact = user_info.mobile_number : this.phoneContact = this.validationHelperService.maskPhone(user_info.mobile_number);
    if (this.selectedDate !== '') {
      this.selectedDate = new Date(this.selectedDate.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/g, '$2/$1/$3'));
      this.selectedDate = this.helperService.formatingVclDate(this.selectedDate);
      this.date = this.selectedDate;
    }
    const financial = this.abreCuentasService.getFinancialInfo();
    const otherFinancial = this.abreCuentasService.getOtherFinancialInfo();
    this.showOtherIncomes = otherFinancial.otherIncomes !== 0 ? true : false;
    this.incomesSourceSelection = this.showOtherIncomes ? 'si' : 'no';
    this.radioIncome = [{
      label: this.copyService.copies.client_data_update.financial.other_income.si,
      elementId: 1,
      checked: this.showOtherIncomes,
      value: 'si',
    },
    {
      label: this.copyService.copies.client_data_update.financial.other_income.no,
      elementId: 2,
      checked: !this.showOtherIncomes,
      value: 'no',
    }];
    /* this.selectOtherOriginIncome = otherFinancial.otherFunds; */
    // tslint:disable-next-line:early-exit
    if (Object.keys(financial).length > 0) {
      financial.origin = this.abreCuentasService.getIncomesOriginSearchSelected().value;
      this.selectOriginIncome = financial.origin,
        // this.formControls.income.setValue(financial.incomes);
        this.formControls.income.setValue(aditional);
      this.formControls.Expenses.setValue(financial.expenses);
      this.formControls.Debts.setValue(financial.debt);
      this.formControls.Goods.setValue(financial.goods);
      // this.income = financial.incomes;
      this.income = aditional;
      this.valueExpenses = financial.expenses;
      this.valueDebts = financial.debt;
      this.valueGoods = financial.goods;
    }
    this.selectOtherOriginIncome = otherFinancial.otherFunds;
    this.valueOtherIncomes = otherFinancial.otherIncomes;
    this.formControls.OtherIncomes.setValue(otherFinancial.otherIncomes);
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
  isSelectIncome(e: any) {
    this.incomesSourceSelection = e.target.value;
    if (e.target.value === 'si') {
      this.showOtherIncomes = true;
      this.reactiveOtherIncomes();
    } else {
      this.other_btn_show = true;
      this.formControls.OtherIncomes.setValue('');
      this.showOtherIncomes = false;
    }
  }

  reactiveOtherIncomes() {
    if (this.formControls.originOtherIncome.value !== '' && this.formControls.OtherIncomes.value !== '') {
      this.other_btn_show = true;
    } else {
      this.other_btn_show = false;
    }
  }

  selectOptionCiiu(ciiuSelected: any) {
    if (ciiuSelected.value) {
      this.calculateCiiuOptions(ciiuSelected.value);
      this.enableDetail = true;
    } else {
      this.formControls.ciiu.setValue('');
      this.enableDetail = false;
    }
  }

  setCiiuGeneralOptions() {
    if (this.ciiu_show && this.laboralData) {
      const ciiu = this.ciiuSelected.ciiu.length === 3 ? '0' + this.ciiuSelected.ciiu : this.ciiuSelected.ciiu;
      const ciiuCode = ciiu.substring(0, 2);
      this.selectedGeneral = {
        ciiu: ciiuCode,
        description: this.optionsCiiu.filter((option: any) => option.ciiu === ciiuCode)[0].description,
      };
      this.calculateCiiuOptions(ciiuCode);
      this.formControls.ciiuGeneral.setValue(this.selectedGeneral.ciiu);
      this.enableDetail = true;
    }
  }

  calculateCiiuOptions(value: string) {
    this.ciiu_options = this.optionsFilter.filter(option => {
      const ciiuSelect = option.ciiu.length === 3 ? '0' + option.ciiu : option.ciiu;
      return ciiuSelect.substring(0, 2) == value;
    });
  }

  reactiveCiiu(e: any) {
    if (e.value.ciiu !== '090') {
      this.company_show = true;
      this.city_work_show = true;
      this.address_work_show = true;
      this.phone_work_show = true;
      this.formControls.company.setValidators([Validators.required]);
      this.formControls.districtWorkValue.setValidators([Validators.required]);
      this.formControls.cityWorking.setValidators([Validators.required]);
      this.formControls.addressWork.setValidators([
        Validators.required, Validators.minLength(4), Validators.maxLength(40),
        Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/)),
      ]);
      this.formControls.phoneCompany.setValidators([Validators.required, Validators.pattern(/^([1-9]{1,1}[0-9]{6,9})$/)]);
    } else {
      this.formControls['company'].setValidators([]); // or clearValidators()
      this.formControls['company'].updateValueAndValidity();
      this.formControls['districtWorkValue'].setValidators([]); // or clearValidators()
      this.formControls['districtWorkValue'].updateValueAndValidity();
      this.formControls['cityWorking'].setValidators([]); // or clearValidators()
      this.formControls['cityWorking'].updateValueAndValidity();
      this.formControls['addressWork'].setValidators([]); // or clearValidators()
      this.formControls['addressWork'].updateValueAndValidity();
      this.formControls['phoneCompany'].setValidators([]); // or clearValidators()
      this.formControls['phoneCompany'].updateValueAndValidity();
      this.company_show = false;
      this.city_work_show = false;
      this.address_work_show = false;
      this.phone_work_show = false;
    }
  }

  inputPhone($event: any) {
    const value = $event.target.value;
    const phone = this.getNumberFormat(value);
    $event.target.value = phone.clearValue;
  }

  outPhone($event: any) {
    const value = $event.target.value;
    const phone = this.getNumberFormat(value);
    $event.target.value = phone.format;
  }

  getNumberFormat(value: string) {
    // const formatNumber = new FormatNumberService();
    return this.formatNumber.formatNumberPhone(value);
  }

  reactiveDatePicker(e) {
    this.date_button = e.target.value !== '' ? true : false;
    this.date = e.target.value;
  }

  reactiveInputChangePhoneWork() {
    const controlPhone = this.formControls.phoneCompany as FormControl;
    controlPhone.setValue(controlPhone.value.slice(0, 10));
    controlPhone.setValue(controlPhone.value.replace(new RegExp(/[^\d]/), ''));
  }

  back() {
    this.confirmData = false;
    this.backLabel = false;
    this.helperService.scrollToTop();
  }

  async next() {
    const a = this.formControls.OtherIncomes.value;
    const maritialValue = this.formControls.civilStatus.value;
    if (!this.confirmData) {
      this.bitacoraService.saveDataInBitacora('confirm_client_data_update');
      this.backLabel = 'Editar';
      this.confirmData = true;
      const maritialStatus = {
        marital_status_code: maritialValue.id,
        marital_status_description: maritialValue.value,
      };
      this.helperService.scrollToTop();
      this.setUserContactInfo();
      this.abreCuentasService.setMaritalStatusInfo(maritialStatus);
      if (this.occupationSelected.name !== 'Pensionado') {
        this.setUserOfficeinfo();
      }
      this.setUserWorkInfo();
      this.setUserFinancialInfo();
      this.setUserOtherFinancialInfo();
      return;
    }
    this.other_btn_show = false;
    this.bitacoraService.saveDataInBitacora('Ini_send_client_data_update');
    // this.stateDateContract = this.validateDateContract();
    // if (!this.stateDateContract) {
    try {
      // if (!this.stateDateContract) {
      await this.captureService.createContactInfo();
      await this.captureService.prospectAddresses();
      if (this.occupationSelected.name !== 'Pensionado') {
        await this.captureService.prospectAddresses('LABORAL');
      }
      await this.captureService.createFinancials();
      await this.callIncomeLoan();
      // }
    } catch (e) {
      this.handleError();
    }
    if ((this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
      this.product_type === BUSINESS_CONST.MULTI) &&
      (this.firmlyApprovedService.isEmpty() &&
        this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme')) {
      await this.getPcoAmount();
      if (!this.pcoAmountValidation) {
        this.productLoaderService.hide();
        return;
      }
    }
    // } else {
    //   this.errorInfo = {
    //     title: '¡Menos de ' + this.timeText + ' no es suficiente!',
    //     description: 'Edita la fecha que ingresaste o intenta nuevamente cuando lleves ' + this.timeText + ' realizando tu actividad',
    //     buttonLabel: this.copyService.copies.error_back_to_edit_date_end,
    //     type: 'date',
    //     buttonAction: '$exit',
    //   };
    //   this.abreCuentasService.setErrorProperty(this.errorInfo);
    //   this.bitacoraService.saveDataInBitacora('Out_send_client_data_update');
    //   this.navigationService.nextStep('502');
    // }

    try {
      // if (!this.stateDateContract) {
      await this.captureService.createFinancials();
      if (
        (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL ||
        this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
        this.product_type === BUSINESS_CONST.MULTI)
        && !this.firmlyApprovedService.isFirmlyApproved()) {
        if ((this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_SAVINGS
          || this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_PAYROLL)
          && this.channelCommunicatorService.getChannelId() !== CHANNEL.PORTALO.CODE) {
          await this.captureService.createClient();
        }
      }
      this.bitacoraService.saveDataInBitacora('Out_send_client_data_update');
      this.advance();
      // }
    } catch (e) {
      this.handleError();
    }
  }

  async callIncomeLoan() {
    if (this.abreCuentasService.haveLoan || this.product_type === BUSINESS_CONST.MULTI) {
      this.bitacoraService.saveDataInBitacora('Ini_loading_Incomes');
      await this.captureService.performIncomes().then((res: any) => {
        if (res === 200) {
          this.bitacoraService.saveDataInBitacora('Out_loading_Incomes');
        }
      });
    }
  }

  advance() {
    const bitacoraEvent = `client_update_confirm`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);

    this.abreCuentasService.hideGenericLoading();
    if (this.abreCuentasService.isGrayZone() && (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.product_type === BUSINESS_CONST.MULTI)) {
      this.navigationService.nextStep('202');
      this.checkLoading();
      return;
    }
    // if (this.product_type === BUSINESS_CONST.MULTI) {
    //   let arrProductMulti = this.abreCuentasService.getProductsSelects();
    //   let strNextStop = '201';
    //   if (arrProductMulti.filter(product => product.flow === BUSINESS_CONST.PRODUCT_TYPE_FREE).length > 0) {
    //     strNextStop = '200';
    //   }
    //   this.navigationService.nextStep(strNextStop);
    // }

    if (!this.loanNormalization) {
      this.navigationService.nextStep('200');
    }
    this.checkLoading();
  }

  handleError() {
    this.abreCuentasService.hideGenericLoading();
    this.navigationService.navigateToGeneralInformation('500');
  }
  checkLoading() {
    if (this.closeLoading) {
      this.productLoaderService.hide();
    }
  }

  // validateDateContract() {
  //   const actualDate = new Date();
  //   this.timeText = this.occupationSelected.id === 1 ? this.formControls.contract.value.timeText : this.independent_option.timeText;
  //   const timeMin = this.occupationSelected.id === 1 ? this.formControls.contract.value.timeMin : this.independent_option.timeMin;
  //   actualDate.setMonth(actualDate.getMonth() - timeMin);
  //   const contract_date = new Date(this.selectedDate.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/g, '$2/$1/$3'));
  //   if (contract_date > actualDate) {
  //     return true;
  //   }
  //   return false;
  // }

  async getPcoAmount() {
    this.productLoaderService.show(this.copyService.copies.show_load_pco,
      this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
    this.bitacoraService.saveDataInBitacora('Ini_loading_PCO');
    await this.captureService.performPco().then(result => {
      if (result !== '200') {
        this.navigationService.navigateToGeneralInformation('127');
        return;
      }
    });
    await this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
    await this.captureService.getChannelComunicator(false, true).then(result2 => {
      this.pcoAmountValidation = true;
      if (result2 === '107' || result2 === '121' || result2 === '130' || result2 === '129' || result2 === '124' || result2 === '127') {
        // if (result2 === '129') {
        //   this.navigationService.pageLoadTag('ErrorProcesoEnTramite', ['pv426', '', 'pv572', '']);
        // }
        if (result2 === '121') {
          this.navigationService.pageLoadTag('ErrorSolicitudNoAprobada', ['pv438', '', '', '']);
        }
        this.navigationService.navigateToGeneralInformation(result2);
        this.pcoAmountValidation = false;
      }

      if (result2 === '17') {
        this.loanNormalization = true;
        this.navigationService.navigateToGeneralInformation(ERROR_LIB.CODE);
        this.bitacoraService.saveDataInBitacora('Normalization_yes');
      } else {
        this.bitacoraService.saveDataInBitacora('Out_loading_PCO');
        this.closeLoading = true;
      }
    }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
  }

  setUserContactInfo() {
    const contactCity = {
      city_code: this.formControls.cityResidence.value.code_dane.slice(-3),
      country_code: this.formControls.cityResidence.value.code_dane.slice(-3),
      province_code: this.formControls.cityResidence.value.code_dane.slice(0, -3),
      description: `${this.formControls.cityResidence.value.city}, ${this.formControls.cityResidence.value.district.district}`,
      bp_city_code: this.formControls.cityResidence.value.code_dane.slice(-3),
      bp_province_code: this.formControls.cityResidence.value.code_dane.slice(0, -3),
      district_id: this.formControls.cityResidence.value.district.district_id,
    };
    const user_info = this.abreCuentasService.getContactInfo();
    const contactInfo = {
      mobile_number: this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE ? this.formControls.phoneContact.value : user_info.mobile_number,
      email: this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE ? this.formControls.emailAddress.value : user_info.email,
      employment_number: this.formControls.phoneCompany.value,
      address: {
        city: contactCity,
        addressInput: this.formControls.addressResidence.value,
        detail: user_info.address.detail ? user_info.address.detail : '',
        address: this.validateAddress('addressResidence'),
        stratum: this.formControls.stratum.value.id,
        housingType: {
          housingId: this.formControls.livingPlace.value.id,
          description: this.formControls.livingPlace.value.name,
        },
      },
    };
    if (this.formControls.ciiu.value) {
      this.selectedCiiu = this.formControls.ciiu.value;
      this.abreCuentasService.setCiiuSelected(this.selectedCiiu);
      this.abreCuentasService.setCiiuDate(this.date);
    }
    this.abreCuentasService.setContactInfo(contactInfo);
  }

  setUserOfficeinfo() {
    if (this.occupationSelected.name === 'Pensionado') {
      const contactCityWork = {
        city_code: '',
        country_code: '',
        province_code: 5,
        description: '',
      };
      this.officeInfo = {
        occupation_id: this.occupationSelected.id,
        company_name: '',
        company_nameInput: '',
        address: {
          city: contactCityWork,
          address: '',
          detail: '',
          addressInput: '',
        },
        office_number: '',
      };
    } else {

      const contactCityWork = {
        city_code: this.formControls.cityWorking.value.code_dane.slice(-3),
        country_code: this.formControls.cityWorking.value.code_dane.slice(-3),
        province_code: this.formControls.cityWorking.value.code_dane.slice(0, -3),
        description: `${this.formControls.cityWorking.value.city}, ${this.formControls.cityWorking.value.district.district}`,
      };
      this.officeInfo = {
        occupation_id: this.occupationSelected.id,
        company_name: this.validateCompany(),
        company_nameInput: this.formControls.company.value,
        address: {
          city: contactCityWork,
          address: this.validateAddress('addressWork'),
          detail: this.formControls.addressWork.value,
          addressInput: this.formControls.addressWork.value,
        },
        office_number: this.formControls.phoneCompany.value,
      };
    }
    this.abreCuentasService.setOfficeInfo(this.occupationSelected.id + '', this.officeInfo);
  }

  setUserWorkInfo() {
    if (!this.contract_show) {
      return;
    }
    this.contract = {
      label: this.formControls.contract.value.label,
      elementId: this.formControls.contract.value.elementId,
      checked: this.formControls.contract.value.checked,
      message: this.formControls.contract.value.message,
      timeText: this.formControls.contract.value.timeText,
      timeMin: this.formControls.contract.value.timeMin,
    };
    const contract = this.typeContracts.find(data => data.checked);
    this.employedModel = {
      typeContract: this.contract,
      contractDate: this.date,
    };
    this.abreCuentasService.setEmployedContractModel(this.employedModel);
  }

  setUserFinancialInfo() {
    this.financialInfo = {
      incomes: + this.formControls.income.value,
      expenses: + this.formControls.Expenses.value,
      debt: + this.formControls.Debts.value,
      goods: + this.formControls.Goods.value,
      origin: this.formControls.origin.value,
      funds: this.formControls.origin.value.value,
      incomes_input: + this.formControls.income.value,
      next: false,
      expensesDiscount: 0,
    };
    this.abreCuentasService.setFinancialInfo(this.financialInfo);

    const financial_origin = {
      id: this.formControls.origin.value.id,
      value: this.formControls.origin.value.value,
    };
    this.abreCuentasService.setIncomesOriginSearchSelected(financial_origin);
  }

  setUserOtherFinancialInfo() {
    this.otherFinancialInfo = {
      otherIncomes: this.incomesSourceSelection === 'si' ? +this.formControls.OtherIncomes.value : 0,
      otherFunds: this.incomesSourceSelection === 'si' ? this.formControls.originOtherIncome.value.value : '',
      otherOrigin: this.incomesSourceSelection === 'si' ? 1 : 0,
    };
    this.abreCuentasService.setOtherFinancialInfo(this.otherFinancialInfo);
  }

  validateAddress(value: string): string {
    const controladdress = this.formControls[value] as FormControl;
    return this.stringHelperService.normalizeAddress(controladdress.value, '');
  }

  validateCompany(): string {
    const controlCompany = this.formControls['company'] as FormControl;
    return this.stringHelperService.normalizeCompany(controlCompany.value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  async getDistrict() {
    await this.requestService.districtBrances().then(response => {
      this.district_option = response.body;
    });
  }

  districtSelect(event: any, type) {
    if (!event.value) {
      if (type === 'personal') {
        this.formGroup.controls.cityResidence.setValue('');
        this.city_option = {};
        this.isDisabledCity = true;
        return;
      }
      this.formGroup.controls.cityWorking.setValue('');
      this.city_option_work = {};
      this.isDisabledCityWork = true;
      return;
    }
    this.requestService.cityBranches(event.value.district_id)
      .then(response => {
        if (type === 'personal') {
          this.city_option = response.body;
          this.isDisabledCity = false;
          return;
        }
        this.city_option_work = response.body;
        this.isDisabledCityWork = false;
      });
  }

}
